module.exports={account_link_complete_message:"Penautan Akun Nexon selesai."};